// env.ts
const isProduction = (): boolean => {
    return import.meta.env.PROD;
};
const getApiBaseUrl = (): string => {
    return isProduction()
        ? 'https://api-website.verdea.app/api'
        : 'http://localhost:8005/api';
};
const shouldUseMockApi = (): boolean => {
    if (isProduction()) {
        return false;
    }

    const mockApiSetting = import.meta.env.VITE_USE_MOCK_API;
    return mockApiSetting !== 'false';
};

export const API_CONFIG = {
    API_BASE_URL: getApiBaseUrl(),
    USE_MOCK_API: shouldUseMockApi()
} as const;